import { render, staticRenderFns } from "./selectProductsPack.vue?vue&type=template&id=ed1ea08c&scoped=true&"
import script from "./selectProductsPack.vue?vue&type=script&lang=js&"
export * from "./selectProductsPack.vue?vue&type=script&lang=js&"
import style0 from "./selectProductsPack.vue?vue&type=style&index=0&id=ed1ea08c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1ea08c",
  null
  
)

export default component.exports